import { Component, OnInit, ChangeDetectorRef, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { UserLoginService } from '../../service/aws/user.login.service';

export class NewPasswordUser {
    username: string;
    existingPassword: string;
    password: string;
}
/**
 * This component is responsible for displaying and controlling
 * the registration of the user.
 */
@Component({
    selector: 'app-requestpassword',
    templateUrl: './request-password.component.html'
})
export class NewPasswordComponent {
    registrationUser: NewPasswordUser;
    router: Router;
    errorMessage: string;

    constructor(public userService: UserLoginService, router: Router) {
        this.router = router;
    }

    OnInit() {
        this.errorMessage = null;
    }

    onRegister() {
        console.log(this.registrationUser);
        this.errorMessage = null;
        // this.userRegistration.newPassword(this.registrationUser, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message != null) { // error
            this.errorMessage = message;
            console.log('result: ' + this.errorMessage);
        } else { // success
            // move to the next step
            this.router.navigate(['/securehome']);
        }
    }

    isLoggedIn(message: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            this.router.navigate(['/securehome']);
        }
    }
}
